// Stub: gateway-backed "flows" don't exist in the standalone hub UI. IntentsTab
// uses this only to populate an optional intent→flow dropdown; returning [] makes
// that selector empty (agent-workflows are the hub-native equivalent) without
// pulling in a gateway dependency.
export interface Flow {
  id: string;
  name: string;
  botId?: string;
  status?: string;
  [k: string]: unknown;
}

export const flowService = {
  async listFlows(_botId?: string, _arg?: unknown, _token?: string | null): Promise<Flow[]> {
    return [];
  },
};
